import { PDF_COLORS, pdfFz, divisorV2 } from "./stylesPDFv2";
import { qrCanvasNode } from "./PDFQr";
import BIWO_LOGO_FOOTER from "./biwoLogoFooter";

/**
 * @param {string} idKiosko
 * @param {string} caption leyenda bajo el QR (varía entre remisión/factura)
 */
export const PDFKioskoQRV2 = (idKiosko, caption = "Escanee para realizar su factura.", alignment = "left") => {
  if (!idKiosko) return {};
  const url = `https://biwo.online/kiosko?kiosko_id=${idKiosko}`;

  const qrNode = { ...qrCanvasNode(url, 48, { quietZone: 2, ecc: "Q" }), margin: [0, 0, 0, 2] };
  const qrBlock =
    alignment === "center"
      ? { columns: [{ width: "*", text: "" }, { width: "auto", stack: [qrNode] }, { width: "*", text: "" }] }
      : qrNode;
  return {
    margin: [0, 3, 0, 0],
    stack: [
      qrBlock,
      {
        text: `Link: ${url}`,
        style: "textoChicoData",
        color: "#4B5563",
        alignment,
        fontSize: pdfFz(3.5),
      },
      {
        text: `Folio: ${idKiosko}`,
        style: "textoChicoData",
        color: "#4B5563",
        alignment,
        fontSize: pdfFz(4.5),
      },
      {
        text: caption,
        style: "textoChicoData",
        color: "#4B5563",
        alignment,
        fontSize: pdfFz(4),
      },
    ],
  };
};

export const PDFBrandFooterV2 = (logoBiwoBase64) => {
  // Si el endpoint manda el logo (logoBiwo) lo usamos tal cual (factura/remisión).
  const backendLogo =
    typeof logoBiwoBase64 === "string" && logoBiwoBase64 ? logoBiwoBase64 : null;
  const src = backendLogo || BIWO_LOGO_FOOTER;
  if (!src) return undefined;

  const fit = backendLogo ? [500, 42] : [500, 15];

  const margin = backendLogo ? [0, -14, 0, 0] : [0, -0.5, 0, 0];
  return {
    image: src,
    fit,
    alignment: "center",
    margin,
  };
};

// pdfMake solo permite un footer por documento, por eso logo y número de página van juntos aquí.
export const PDFBrandFooterConNumeroV2 = (logoBiwoBase64) => (currentPage, pageCount) => {
  const logoNode = PDFBrandFooterV2(logoBiwoBase64);
  return {
    stack: [
      ...(logoNode ? [logoNode] : []),
      {
        text: `Página ${currentPage} de ${pageCount}`,
        alignment: "right",
        fontSize: pdfFz(7),
        color: "#888",
        margin: [0, 2, 30, 0],
      },
    ],
  };
};

/**

 * @param {string} texto
 */
export const PDFTextoAdicionalV2 = (texto) => {
  if (!texto) return {};
  return {
    margin: [0, 8, 0, 4],
    stack: [
      divisorV2(PDF_COLORS.line, 4),
      { text: texto, style: "textoAdicional", margin: [0, 2, 0, 0] },
    ],
  };
};

export default PDFKioskoQRV2;
